<template>
  <table-wrapper class="table_scroll">
    <template slot="thead">
      <table-row class="table_width">
        <table-heading
          class="text-center"
        >
          日期
        </table-heading>
        <table-heading
          class="text-center"
        >
          時間
        </table-heading>

        <table-heading class="text-center">
          演講主題
        </table-heading>
        <table-heading>
          報名狀態
        </table-heading>
        <table-heading />
      </table-row>
    </template>

    <table-row
      v-for="lecture in careerLectureEnrolledRecordsGetter"
      :key="lecture.lecture_id"
      class="table_width"
    >
      <table-data
        class="text-center"
      >
        {{ lecture.lecture_date_time_start || new Date() | moment("YYYY/MM/DD") }}
      </table-data>
      <table-data
        class="text-center"
      >
        {{ lecture.lecture_date_time_start || new Date() | moment("HH:mm") }}~{{ lecture.lecture_date_time_end || new Date() | moment("HH:mm") }}
      </table-data>

      <table-data>
        <router-link :to="`/lectures/internship/${lecture.lecture_id}`">
          {{ lecture.lecture_topic }}
        </router-link>
      </table-data>
      <table-data
        :class="{
          'text-center': true,
          'text-success': lecture.lecture_enrollment_status === 1,
          'text-warning': lecture.lecture_enrollment_status === 2,
          'text-muted': lecture.lecture_enrollment_status === 3
        }"
      >
        {{ lecture.lecture_enrollment_status | enrollmentStatus }}
      </table-data>
      <table-data>
        <button-wrapper
          v-if="$moment().isBefore(lecture.lecture_enrollment_deadline)"
          @click.prevent="toggleEnrollment(lecture.lecture_id, $event)"
        >
          {{ lecture.lecture_enrollment_status < 3 ? '取消報名' : '重新報名' }}
        </button-wrapper>
        <span
          v-else
          class="text-muted"
        >報名截止</span>
      </table-data>
    </table-row>
  </table-wrapper>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import TableWrapper from '~components/common/tables'
import TableRow from '~components/common/tables/Row'
import TableData from '~components/common/tables/Data'
import TableHeading from '~components/common/tables/Heading'
import ButtonWrapper from '~components/common/buttons'
import { enrollmentStatus } from '~utils/filters'
export default {
  name: 'EnrolledInternship',
  components: {
    TableWrapper,
    TableRow,
    TableData,
    TableHeading,
    ButtonWrapper
  },
  filters: {
    enrollmentStatus
  },
  computed: {
    ...mapGetters('pages/students', [
      'careerLectureEnrolledRecordsGetter'
    ])
  },
  async created () {
    await this.getCareerLectureEnrolledRecords({
      type: 4
    })
  },
  methods: {
    ...mapActions('pages/students', [
      'getCareerLectureEnrolledRecords',
      'cancelEnrolledCareerLectureById'
    ]),
    async toggleEnrollment (enrollmentId) {
      await this.cancelEnrolledCareerLectureById(enrollmentId)
      await this.getCareerLectureEnrolledRecords({
        type: 4
      })
    },
    getPage (page) {
      this.getCareerLectureEnrolledRecords({
        type: 4,
        page })
    }
  }
}
</script>

<style lang="scss" scoped>
.table_scroll{
  overflow-x:scroll!important;
}
.table_width{
  width: 1000px;
}

</style>
